'use client';

import * as React from 'react';
import type { Transition, Variants } from 'framer-motion';
import { motion, useAnimation } from 'framer-motion';

interface IconProps {
	isHovered: boolean;
}

const pathTransition: Transition = {
	duration: 0.3,
	delay: 0.1,
	opacity: { delay: 0.15 },
};

const pathVariants: Variants = {
	normal: {
		pathLength: 1,
		opacity: 1,
		d: 'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71',
	},
	animate: {
		pathLength: [0, 1],
		opacity: [0, 1],
		d: 'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71',
	},
};

const secondPathVariants: Variants = {
	normal: {
		pathLength: 1,
		opacity: 1,
		d: 'M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71',
	},
	animate: {
		pathLength: [0, 1],
		opacity: [0, 1],
		d: 'M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71',
	},
};

export function LinkIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<motion.path
					transition={pathTransition}
					variants={pathVariants}
					animate={controls}
				/>
				<motion.path
					transition={pathTransition}
					variants={secondPathVariants}
					animate={controls}
				/>
			</svg>
		</div>
	);
}
